"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAppUserRole = exports.AppUserRole = void 0;
const validate_1 = require("../utils/validate");
var AppUserRole;
(function (AppUserRole) {
    AppUserRole["PARTICIPANT"] = "PARTICIPANT";
    AppUserRole["HOST"] = "HOST";
    AppUserRole["ADMIN"] = "ADMIN";
})(AppUserRole = exports.AppUserRole || (exports.AppUserRole = {}));
const APP_USER_ROLE = Object.values(AppUserRole);
function getAppUserRole(value, valueName) {
    if (!APP_USER_ROLE.includes(value)) {
        throw validate_1.typeError('AppUserRole', value, valueName);
    }
    return value;
}
exports.getAppUserRole = getAppUserRole;
//# sourceMappingURL=AppUserRole.js.map